// Generated by LiveScript 1.6.0
var ref$, id, log, max, int, head, getWidgetAtDom, pub, sub, buttonActiveClass, MultiServdController, slice$ = [].slice;
ref$ = require('utils'), id = ref$.id, log = ref$.log, max = ref$.max, int = ref$.int, head = ref$.head;
getWidgetAtDom = require('../widgets').getWidgetAtDom;
ref$ = require('pubsub'), pub = ref$.pub, sub = ref$.sub;
buttonActiveClass = 'active';
module.exports = MultiServdController = function($page, $$){
  var $buttons, $menus, servdInstances, res$, i$, len$, el, state, servd, setHeight, selectServd, matchMasterHeight, setActiveMenu, swapByButton, resolveDeeplink, that;
  $buttons = $$('[data-menu-select]');
  $menus = $$('[data-menu]');
  res$ = [];
  for (i$ = 0, len$ = $menus.length; i$ < len$; ++i$) {
    el = $menus[i$];
    res$.push(getWidgetAtDom(el));
  }
  servdInstances = res$;
  state = {
    current: 0,
    heights: (function(){
      var i$, ref$, len$, resultObj$ = {};
      for (i$ = 0, len$ = (ref$ = servdInstances).length; i$ < len$; ++i$) {
        servd = ref$[i$];
        resultObj$[servd.config.menu] = 0;
      }
      return resultObj$;
    }())
  };
  setHeight = function(h){
    return $page.height(h + 90);
  };
  selectServd = function(mid){
    return head(servdInstances.filter(function(it){
      return it.config.menu === mid;
    }));
  };
  matchMasterHeight = function(height, which){
    state.heights[which] = height;
    return setHeight(state.heights[state.current]);
  };
  setActiveMenu = function(menuId){
    if (!menuId) {
      return;
    }
    state.current = menuId;
    $buttons.removeClass(buttonActiveClass).filter("[data-menu-select='" + menuId + "']").addClass(buttonActiveClass);
    return $menus.hide().filter("[data-menu='" + menuId + "']").css('display', 'flex');
  };
  swapByButton = function(){
    var menuId;
    menuId = $(this).data('menu-select');
    setActiveMenu(menuId);
    return selectServd(menuId).setInitialState();
  };
  resolveDeeplink = function(ixChain){
    var ref$, menuId, chain, servd;
    if (ixChain[0] === 0 || ixChain.length === 0) {
      servdInstances.map(function(it){
        return it.setInitialState();
      });
      setActiveMenu(servdInstances[0].config.menu);
      return;
    }
    ref$ = ixChain.map(int), menuId = ref$[0], chain = slice$.call(ref$, 1);
    setActiveMenu(menuId);
    servd = selectServd(menuId);
    if (chain.length) {
      return servd.menuDisplay(chain);
    } else {
      return servd.setInitialState();
    }
  };
  $buttons.on('click', swapByButton);
  servdInstances.map(function(it){
    return it.onHeightChange(matchMasterHeight);
  });
  sub('menu-display', function(it){
    return resolveDeeplink(it.map(int));
  });
  sub('history-push', function(arg$){
    var section, ixChain, title;
    section = arg$[0], ixChain = arg$[1], title = arg$[2];
    if (ixChain != null) {
      return resolveDeeplink(ixChain.split('-').map(int));
    }
  });
  if (that = global.servdCallback) {
    servdInstances[0].onDataReady(that);
  }
  return servdInstances.map(function(it){
    return it.provokeHeightReport();
  });
};
//# sourceMappingURL=data:application/json;base64,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

